import lodash from 'lodash'
import React, { useEffect } from 'react'
import { ReactElement } from 'react'

import CurrencyInput from '../../../../../../1stlog-ui/src/components/CurrencyInput'
import { useField } from '../../../../../../1stlog-ui/src/components/Field'
import useOrderEntry from '../../../useOrderEntry'

const CustomPriceForm = (): ReactElement => {
  const { currentCustomer } = useOrderEntry()

  const defaultCurrency = lodash.get(currentCustomer, 'defaultCurrency', 'CHF')

  const [buyPrice, setBuyPrice] = useField('buyPrice', { asState: true })

  const [sellPrice, setSellPrice] = useField('sellPrice', { asState: true })

  useEffect(() => {
    if (!buyPrice) {
      setBuyPrice({ currency: defaultCurrency, value: undefined })
    }
  }, [buyPrice])

  useEffect(() => {
    if (!sellPrice) {
      setSellPrice({ currency: defaultCurrency, value: undefined })
    }
  }, [sellPrice])

  return (
    <div>
      <div style={{ width: '400px' }}>
        <CurrencyInput
          name="buyPrice"
          label={i18n.t(
            'label_buy_price_for-sonderfahrt',
            'Einkaufskosten (bei Sonderfahrten bitte angeben)',
          )}
        />
      </div>
      <div style={{ width: '400px' }}>
        <CurrencyInput
          name="sellPrice"
          label={i18n.t('lable_sell_price', 'Verkaufspreis')}
        />
      </div>
    </div>
  )
}

export default CustomPriceForm
